import { render, staticRenderFns } from "./CompetitorsTable.vue?vue&type=template&id=abf82e72&scoped=true&"
import script from "./CompetitorsTable.vue?vue&type=script&lang=ts&"
export * from "./CompetitorsTable.vue?vue&type=script&lang=ts&"
import style0 from "./CompetitorsTable.vue?vue&type=style&index=0&id=abf82e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf82e72",
  null
  
)

export default component.exports